export default __webpack_public_path__ + "static/media/information--highway-reference-location--g1.fd97a9dc.png";